import { SlimOnly } from './SlimOnly';
import { DefaultOnly } from './DefaultOnly';
import { SlimProps } from './SlimProps';

const Tools = {
    SlimOnly,
    DefaultOnly,
    SlimProps
};

export default Tools;
